<template>
  <div class="manage-timetrigger-modal">
    <div class="modal-backdrop"></div>

    <div class="modal-fullscreen">
      <div v-if="isLoading" class="loadingoverlay">
        <div class="progress-icon"></div>
      </div>
      <div class="header" v-if="!isLoading">
        <div></div>
        <div class="" @click="close">
          <span class="btn-close"></span>
        </div>
      </div>
      <div
        class="content fancy-scroll"
        v-if="!isLoading"
        @scroll.passive="showScrollbar"
      >
        <div v-if="step === 0" class="step-container">
          <div class="input-container">
            <label>Zeitplanname</label>
            <input
              type="text"
              placeholder="Zeitplanname eingeben"
              v-model="formData.scheduleName"
              @input="validateInput($event, 'scheduleName')"
              :class="{
                'validation-error': isValidationError('scheduleName'),
              }"
              maxlength="64"
            />
          </div>
          <div class="input-container">
            <label>Beschreibung</label>
            <textarea
              rows="5"
              placeholder="Beschreibung eingeben"
              v-model="formData.scheduleDescription"
              :class="{
                'validation-error': isValidationError('scheduleDescription'),
              }"
              @input="validateInput($event, 'scheduleDescription')"
              maxlength="512"
            />
          </div>
          <div class="occurence-wrapper">
            <div class="input-container">
              <label>Status</label>

              <div class="status-schedule-container">
                <label
                  class="radio-container"
                  v-for="status in constants.cronStatus"
                  :key="`${status.name}-${status.id}`"
                  :for="`${status.name}-${status.id}`"
                  @click="setScheduleStatus(status)"
                >
                  <input
                    type="radio"
                    :id="`${status.name}-${status.id}`"
                    name="scheduleStatus"
                    :value="status.name"
                    v-model="formData.scheduleStatus"
                    :checked="isScheduleStatusSelected(status.name)"
                  />
                  <div>
                    <label :for="`${status.name}-${status.id}`">{{
                      status.label
                    }}</label>
                    <p class="w-full status-description">
                      {{ status.description }}
                    </p>
                  </div>
                </label>
              </div>
            </div>
            <div class="input-container">
              <label>Zeitplanart</label>
              <div class="occurence-container">
                <div
                  class="radio-container"
                  v-for="occurence in constants.scheduleOccurence"
                  :key="`${occurence.name}-${occurence.id}`"
                  @click="setSchedules(occurence)"
                >
                  <input
                    type="radio"
                    :id="`${occurence.name}-${occurence.id}`"
                    name="schedules"
                    value="HTML"
                    :checked="isOccurenceSelected(occurence.name)"
                  />
                  <label :for="`${occurence.name}-${occurence.id}`">{{
                    occurence.label
                  }}</label>
                </div>
              </div>
            </div>

            <div class="schedule-pattern-container">
              <div
                class="input-container"
                v-if="isScheduleOccurenceVisible('one_time_schedule')"
              >
                <label>Datum und Uhrzeit</label>
                <div class="date-time-container">
                  <div class="date-time-input-container">
                    <input
                      type="datetime-local"
                      class="datetime-local"
                      v-model="formData.oneTimeSchedule.dateTime"
                      :class="{
                        'validation-error': isValidationError('dateTime'),
                      }"
                      @input="checkValidityOnInput($event, 'dateTime', true)"
                    />
                  </div>
                  <div class="date-time-input-container">
                    <select
                      disabled
                      class="datetime-local"
                      v-model="formData.timeZone"
                    >
                      <option
                        v-for="zones in constants.timeZones"
                        :value="zones"
                        :key="zones"
                      >
                        {{ getTimeZones(zones) }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div v-if="isScheduleOccurenceVisible('recurring_schedule')">
                <div class="input-container">
                  <label>Zeitplantyp</label>

                  <div class="recurring-schedule-container">
                    <div
                      class="radio-container"
                      v-for="recurringSchedule in constants.recurringSchedulePattern"
                      :key="`${recurringSchedule.name}-${recurringSchedule.id}`"
                      @click="setScheduleTypes(recurringSchedule)"
                      :class="{
                        'validation-error': isValidationError(
                          'selectedRecurringScheduleType'
                        ),
                      }"
                    >
                      <input
                        type="radio"
                        :id="`${recurringSchedule.name}-${recurringSchedule.id}`"
                        name="recurringSchedules"
                        value="HTML"
                        :checked="
                          isRecurringScheduleSelected(recurringSchedule.name)
                        "
                      />
                      <div>
                        <label
                          :for="`${recurringSchedule.name}-${recurringSchedule.id}`"
                          >{{ recurringSchedule.label }}</label
                        >
                        <p class="w-full recurring-description">
                          {{ recurringSchedule.description }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="input-container rate-expression-main-container"
                  v-if="isRecurringScheduleTypeVisible('rate_based_schedule')"
                >
                  <div
                    class="date-time-input-container rate-expression-timezone-input"
                  >
                    <label>Zeitzone</label>
                    <select
                      disabled
                      class="datetime-local"
                      v-model="formData.timeZone"
                    >
                      <option
                        v-for="zones in constants.timeZones"
                        :value="zones"
                        :key="zones"
                      >
                        {{ getTimeZones(zones) }}
                      </option>
                    </select>
                  </div>
                  <div class="rate-expression-wrapper">
                    <div>
                      <label>Zeitwert</label>
                      <div class="rate-expression-container">
                        <div>
                          <input
                            type="number"
                            placeholder="Wert"
                            min="0"
                            v-model="
                              formData.recurringSchedule.rateExpression.value
                            "
                            @input="
                              validateInput($event, 'rateExpressionValue')
                            "
                            :class="{
                              'validation-error': inputsErrorArray.includes(
                                'rateExpressionValue'
                              ),
                            }"
                          />
                        </div>

                        <div
                          class="dropdown-container"
                          :class="{
                            'validation-error': isValidationError(
                              'rateExpressionFrequency'
                            ),
                          }"
                        >
                          <generalDropdown
                            className="frequency-general-dropdown"
                          >
                            <template v-slot:selectFilter>
                              {{ getRateExpressionFrequencyLabel() }}
                            </template>
                            <template v-slot:optionData>
                              <b-dropdown-item
                                v-for="rates in constants.rateExpressionValues"
                                :key="rates.value"
                                @click="setrateExpressionFrequency(rates)"
                              >
                                {{ rates.label }}
                              </b-dropdown-item>
                            </template>
                          </generalDropdown>
                        </div>
                      </div>
                    </div>
                    <div>
                      <label>Startdatum</label>
                      <input
                        class="datetime-local"
                        type="datetime-local"
                        v-model="
                          formData.recurringSchedule.rateExpression.startDate
                        "
                        :class="{
                          'validation-error': isValidationError('startDate'),
                        }"
                        @input="checkValidityOnInput($event, 'startDate', true)"
                      />
                    </div>
                    <div>
                      <label>Enddatum</label>
                      <input
                        class="datetime-local"
                        type="datetime-local"
                        v-model="
                          formData.recurringSchedule.rateExpression.endDate
                        "
                        :class="{
                          'validation-error': isValidationError('endDate'),
                        }"
                        @input="checkValidityOnInput($event, 'endDate', true)"
                      />
                    </div>
                  </div>
                </div>
                <div
                  class="input-container"
                  v-if="isRecurringScheduleTypeVisible('cron_based_schedule')"
                >
                  <label>Cron-Ausdruck</label>
                  <div class="cron-expression-container">
                    <div
                      class="cron-input-container"
                      v-for="(cron, i) in constants.cronExpressionValues"
                      :key="`${cron.name}-${i}`"
                    >
                      <input
                        type="text"
                        v-model="
                          formData.recurringSchedule.cronExpression[cron.name]
                        "
                        @input="validateInput($event, cron.name)"
                        :class="{
                          'validation-error': isValidationError(cron.name),
                        }"
                      />
                      <label>{{ cron.label }}</label>
                    </div>
                  </div>
                  <div
                    v-if="isInValidCronExpression"
                    class="invalid-cron-expression"
                  >
                    <p>Der eingegebene CRON-Ausdruck ist ungültig</p>
                  </div>
                  <div
                    v-if="getNextTenTriggers.length"
                    class="cron-next-triggers-main-container mt-4"
                  >
                    <p class="cron-next-triggers-title mb-2">
                      Auslösedatum der nächsten 10
                    </p>
                    <div class="cron-next-triggers-container">
                      <div
                        v-for="(nextTrigger, i) in getNextTenTriggers"
                        :key="`${nextTrigger}-${i}`"
                      >
                        {{ nextTrigger }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- flexible window selection -->
            <div>
              <div class="input-container flexible-time-window-container">
                <label>Flexibles Zeitfenster</label>
                <div
                  class="dropdown-container"
                  :class="{
                    'validation-error': isValidationError(
                      'rateExpressionFrequency'
                    ),
                  }"
                >
                  <generalDropdown className="frequency-general-dropdown">
                    <template v-slot:selectFilter>
                      {{ getFlexibleTimeWinodwLabel() }}
                    </template>
                    <template v-slot:optionData>
                      <b-dropdown-item
                        v-for="time in constants.flexibleTimeWindowList"
                        :key="time.value"
                        @click="onSelectFlexibleTimeWindow(time)"
                      >
                        {{ time.label }}
                      </b-dropdown-item>
                    </template>
                  </generalDropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="step === 1" class="step-container">
          <div class="input-container">
            <label>Ziel auswählen</label>
            <div class="target-container">
              <div
                class="radio-container"
                v-for="targetCategory in constants.targetCategoryList"
                :key="`${targetCategory.name}-${targetCategory.id}`"
                @click="setTargetCategory(targetCategory)"
                :class="{
                  'disabled-radio-container':
                    targetCategory.name === 'Database',
                }"
              >
                <input
                  type="radio"
                  :id="`${targetCategory.name}-${targetCategory.id}`"
                  name="targets"
                  value="HTML"
                  :checked="isTargetCategorySelected(targetCategory.name)"
                  :disabled="targetCategory.name === 'Database'"
                />
                <label :for="`${targetCategory.name}-${targetCategory.id}`">{{
                  targetCategory.label
                }}</label>
              </div>
            </div>
          </div>
          <div class="search-section">
            <div class="workFlowSearch1">
              <input
                type="text"
                class="workflowsearchinput"
                v-model="workFlowSearch"
                v-if="isTargetCategorySelected('Workflow')"
                placeHolder="Suchen"
              />
              <img
                src="../../assets/img/search-icon.svg"
                class=""
                width="20"
                height="20"
                alt=""
              />
            </div>
            <div
              class="refresh-button"
              :class="{ rotation: isRefreshing }"
              @click="onRefreshFlowList()"
              v-b-tooltip.hover
              title="Aktualisieren"
            >
              <img src="../../assets/img/refresh.svg" />
            </div>
          </div>

          <div
            class="grid-container fancy-scroll"
            @scroll.passive.stop="showScrollbar"
          >
            <div
              class="target-grid-block"
              v-for="(target, i) in getTargetList()"
              :key="target.id"
            >
              <div
                class="target-grid-block-inner"
                @click="setSelectedTarget(target)"
              >
                <div>
                  <i class="fa fa-network-wired"></i>
                </div>
                <div>{{ target.name }}</div>
                <div>
                  <input
                    type="radio"
                    :id="`targets-${i}-${target.id}`"
                    name="targetslist"
                    value="HTML"
                    :checked="istargetSelected(target.id)"
                  />
                </div>
              </div>
            </div>
          </div>

          <div v-if="formData.target.selectedTarget">
            <div class="input-container">
              <label>API Endpoint</label>
              <div class="d-flex justify-content-between">
                <div
                  class="dropdown-container api-endpoint-dropdown-container"
                  :class="
                    formData.target.endPoint === 'custom' ? 'w-48' : 'w-100'
                  "
                >
                  <generalDropdown class="api-endpoint-general-dropdown w-100">
                    <template v-slot:selectFilter>
                      <span class="w-100 text-start">{{
                        getSelectedAPiEndPoint.label
                      }}</span>
                    </template>
                    <template v-slot:optionData>
                      <b-dropdown-item
                        v-for="option in apiVersionOptions"
                        :key="option.value"
                        @click="onSelectApiEndPoint(option)"
                      >
                        {{ option.label }}
                      </b-dropdown-item>
                    </template>
                  </generalDropdown>
                </div>

                <div class="w-48" v-if="formData.target.endPoint === 'custom'">
                  <input
                    type="text"
                    placeholder="Benutzerdefinierter API-Endpunkt"
                    @input="validateInput($event, 'customURLendPoint')"
                    v-model="formData.target.customURLendPoint"
                    :class="{
                      'validation-error':
                        isValidationError('customURLendPoint'),
                    }"
                  />
                </div>
              </div>
            </div>
            <div class="input-container">
              <label>URL-Parameter</label>
              <input
                type="text"
                placeholder="URL-Parameter für den Querystring"
                @input="validateInput($event, 'queryString')"
                v-model="formData.target.queryString"
                :class="{
                  'validation-error': isValidationError('queryString'),
                }"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="footer" v-if="!isLoading">
        <button
          v-if="step === 1"
          class="cancel-btn"
          @click="toggleSteps('prev')"
        >
          Zurück
        </button>
        <div></div>
        <button
          class="save-btn"
          @click="
            toggleSteps(
              step === 0 ? 'next' : mode === 'add' ? 'save' : 'update'
            )
          "
        >
          {{ getSaveBtnText }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import { getCustomDatabaseItem } from '../../services/customdb.service';
import GeneralDropdown from '../core/general-dropdown.vue';
import { addTableItem, updateTableItem } from '../../services/userTable';
import {
  debouncer,
  getTimezoneDifference,
  utcToZonedTime,
  convertDateToUTCIgnoringTimezone,
  changeDateStringLocaleToDe,
} from '../../utils/helpers';
import {
  isValidCronRulePart,
  getNextTriggers,
  hasOnlyOneOfDayOfWeekAndDayOfMonthSpecified,
  CRON_PART_TYPE,
} from '@/utils/helpers/CronParser.js';

export default {
  name: 'ManageTimeTriggerModal',
  data() {
    return {
      step: 0,
      isLoading: false,
      editItemData: null,
      isRefreshing: false,
      savedRateExpressionStartDate: null,
      workflowList: [],
      savedOneTimeScheduleDate: null,
      formData: {
        scheduleName: null,
        scheduleDescription: null,
        selectedScheduleOccurence: null,
        scheduleStatus: 'ENABLED',
        timeZone: 'Europe/Berlin',
        flexibleTimeWindow: {
          mode: 'OFF',
          maximumWindowInMinutes: 0,
        },
        oneTimeSchedule: {
          dateTime: null,
        },

        recurringSchedule: {
          selectedRecurringScheduleType: null,
          rateExpression: {
            value: null,
            frequency: null,
            startDate: null,
            endDate: null,
          },
          cronExpression: {
            minutes: null,
            hours: null,
            dayOfMonth: null,
            month: null,
            dayOfWeek: null,
            year: null,
          },
        },

        target: {
          selectedTargetCategory: null,
          selectedTarget: null,
          endPoint: 'v6',
          customURLendPoint: null,
          queryString: null,
        },
      },

      inputsErrorArray: [],

      constants: {
        scheduleOccurence: [
          { label: 'Einmaliger Zeitplan', name: 'one_time_schedule', id: 1 },
          {
            label: 'Wiederkehrender Zeitplan',
            name: 'recurring_schedule',
            id: 2,
          },
        ],
        recurringSchedulePattern: [
          {
            label: 'Einfacher Zeitplan',
            description:
              'Ein Zeitplan, der regelmäßig ausgeführt wird, z. B. alle 10 Minuten oder alle 3 Tage.',
            name: 'rate_based_schedule',
            id: 1,
          },
          {
            label: 'Fortgeschrittener Zeitplan',
            description:
              'Ein Zeitplan, der mit einem Cron-Ausdruck festgelegt wurde und zu einer bestimmten Zeit ausgeführt wird, z. B. 8:00 Uhr am ersten Montag eines jeden Monats oder jeden 3 Tag um 10:00.',
            name: 'cron_based_schedule',
            id: 2,
          },
        ],
        targetCategoryList: [
          { label: 'Workflow', name: 'Workflow', id: 1 },
          { label: 'Datenbank', name: 'Database', id: 2 },
        ],
        rateExpressionValues: [
          { label: 'Minuten', value: 'minutes' },
          { label: 'Stunden', value: 'hours' },
          { label: 'Tage', value: 'days' },
        ],
        cronExpressionValues: [
          { label: 'Minuten', name: 'minutes' },
          { label: 'Stunden', name: 'hours' },
          { label: 'Tag des Monats', name: 'dayOfMonth' },
          { label: 'Monat', name: 'month' },
          { label: 'Tag der Woche', name: 'dayOfWeek' },
          { label: 'Jahr', name: 'year' },
        ],
        timeZones: ['Europe/Berlin'],
        flexibleTimeWindowList: [
          {
            label: 'Ohne',
            value: 0,
          },
          {
            label: '15 Minuten',
            value: 15,
          },

          {
            label: '30 Minuten',
            value: 30,
          },
          {
            label: '45 Minuten',
            value: 45,
          },
          {
            label: '1 Stunde',
            value: 60,
          },
          {
            label: '2 Stunden',
            value: 120,
          },
        ],
        cronStatus: [
          {
            id: 1,
            label: 'Aktiv',
            name: 'ENABLED',
            description:
              'Der Zeitauslöser ist aktiv und wird zur geplanten Zeit ausgeführt.',
          },
          {
            id: 2,
            label: 'Inaktiv',
            name: 'DISABLED',
            description:
              'Der Zeitauslöser ist inaktiv und es wird keine Aktion ausgeführt.',
          },
        ],
      },

      apiVersionOptions: [
        { label: 'V4', value: 'v4' },
        { label: 'V5', value: 'v5' },
        { label: 'V6', value: 'v6' },
        { label: 'V7', value: 'v7' },
        { label: 'V8', value: 'v8' },
        { label: 'V9', value: 'v9' },
        { label: 'Benutzerdefiniert', value: 'custom' },
      ],
      workFlowSearch: '',
    };
  },
  props: {
    mode: {
      required: true,
      type: String,
    },
    editData: {
      required: false,
      type: Object,
    },
    databaseName: {
      required: true,
      type: String,
    },
    isCopyDatabaseItem: {
      type: Boolean,
    },
  },
  methods: {
    toggleModal(visible, mode, data) {
      this.$emit('toggleTimeTriggerModal', visible, mode, data);
    },
    getRateExpressionFrequencyLabel() {
      let frequency = this.formData.recurringSchedule.rateExpression.frequency;
      if (frequency !== null) {
        return this.constants.rateExpressionValues.find(
          (el) => el.value === frequency
        ).label;
      }

      return 'Frequenz auswählen...';
    },
    getFlexibleTimeWinodwLabel() {
      const frequency = this.formData.flexibleTimeWindow.maximumWindowInMinutes;
      if (frequency !== null) {
        return this.constants.flexibleTimeWindowList.find(
          (el) => el.value === frequency
        )?.label;
      }

      return 'select';
    },
    async onTimeTriggerUpdate(itemData) {
      try {
        this.isLoading = true;
        const formdata = this.sanatizeData();
        const tempPayload = this.getTimeTriggerPayload(formdata);
        const tempPayloadKeys = Object.keys(tempPayload);
        const tempObj = {};

        Object.keys(itemData).map((el) => {
          if (!tempPayloadKeys.includes(el)) {
            tempObj[el] = itemData[el];
          }
        });

        const finalPayload = { ...tempPayload, ...tempObj };
        const response = await updateTableItem(this.databaseName, {
          item: finalPayload,
        });

        if (response && response.status === 200 && response.data) {
          this.showToaster(
            'Artikel erfolgreich aktualisiert',
            'Erfolg',
            'success'
          );
          this.isLoading = false;
          this.toggleModal(false, null, null);
          this.$emit('refreshData');
        }
      } catch (error) {
        this.isLoading = false;
        this.showToaster(
          error?.data?.message ||
            'Ops, something went wrong. Please try again.',
          'Fehlerhaft !',
          'danger'
        );
      }
    },
    async onTimeTriggerSave() {
      const formdata = this.sanatizeData();
      this.isLoading = true;
      try {
        const payload = this.getTimeTriggerPayload(formdata);

        const response = await addTableItem(this.databaseName, {
          item: payload,
        });

        if (
          response &&
          response.status === 200 &&
          response.data &&
          response.data.item_id
        ) {
          this.isLoading = false;
          if (this.isCopyDatabaseItem)
            this.$emit('toggleCopyDatabaseItem', false);
          this.toggleModal(false, null, null);
          this.$emit('refreshData');
        }
      } catch (error) {
        this.isLoading = false;
        if (this.isCopyDatabaseItem)
          this.$emit('toggleCopyDatabaseItem', false);
        this.showToaster(
          error.data?.message ? error.data?.message : error,
          'Fehlerhaft !',
          'danger'
        );
      }
    },
    getTimeTriggerPayload(formdata) {
      const {
        scheduleName,
        scheduleDescription,
        selectedScheduleOccurence,
        oneTimeSchedule,
        recurringSchedule,
        timeZone,
        target,
        flexibleTimeWindow,
        scheduleStatus,
      } = formdata;

      return {
        schedulename: scheduleName,
        scheduledescription: scheduleDescription,
        occurence: selectedScheduleOccurence.name,
        dateandtime: oneTimeSchedule.dateTime,
        timeZone: timeZone,
        state: scheduleStatus,
        scheduletype: recurringSchedule.selectedRecurringScheduleType
          ? recurringSchedule.selectedRecurringScheduleType.name
          : null,
        rateexpressionfrequency: recurringSchedule.rateExpression.frequency,
        rateexpressionvalue: recurringSchedule.rateExpression.value,
        targetcategory: target.selectedTargetCategory.name,
        targetid: target.selectedTarget.id,
        apiEndPoint:
          target.endPoint !== 'custom'
            ? `${process.env.VUE_APP_FLOW_RUNNER_BASE_URL}/${target.endPoint}`
            : target.customURLendPoint,
        endPoint: target.endPoint,
        urlQueryString: target.queryString,
        cronexpressionminutes: recurringSchedule.cronExpression.minutes,
        cronexpressionhours: recurringSchedule.cronExpression.hours,
        cronexpressiondayOfMonth: recurringSchedule.cronExpression.dayOfMonth,
        cronexpressionmonth: recurringSchedule.cronExpression.month,
        cronexpressiondayOfWeek: recurringSchedule.cronExpression.dayOfWeek,
        cronexpressionyear: recurringSchedule.cronExpression.year,
        rateexpressionstartdate: recurringSchedule.rateExpression.startDate,
        rateexpressionenddate: recurringSchedule.rateExpression.endDate,
        flexibletimewindow: {
          Mode: flexibleTimeWindow.mode,
          ...(flexibleTimeWindow.mode === 'FLEXIBLE' && {
            MaximumWindowInMinutes: flexibleTimeWindow.maximumWindowInMinutes,
          }),
        },
      };
    },
    istargetSelected(targetID) {
      return (
        this.formData.target.selectedTarget &&
        this.formData.target.selectedTarget.id == targetID &&
        this.formData.target.selectedTarget.selectedTargetCategory ===
          this.formData.target.selectedTargetCategory.name
      );
    },
    isTargetCategorySelected(targetCategory) {
      return (
        this.formData.target.selectedTargetCategory &&
        this.formData.target.selectedTargetCategory.name === targetCategory
      );
    },
    isRecurringScheduleTypeVisible(type) {
      return (
        this.formData.recurringSchedule.selectedRecurringScheduleType &&
        this.formData.recurringSchedule.selectedRecurringScheduleType.name ===
          type
      );
    },
    isScheduleOccurenceVisible(occurence) {
      return (
        this.formData.selectedScheduleOccurence &&
        this.formData.selectedScheduleOccurence.name === occurence
      );
    },
    isOccurenceSelected(occurence) {
      return (
        this.formData.selectedScheduleOccurence &&
        this.formData.selectedScheduleOccurence.name === occurence
      );
    },
    isRecurringScheduleSelected(recurringScheduleName) {
      return (
        this.formData.recurringSchedule.selectedRecurringScheduleType &&
        this.formData.recurringSchedule.selectedRecurringScheduleType.name ===
          recurringScheduleName
      );
    },
    isScheduleStatusSelected(status) {
      return (
        this.formData.scheduleStatus && this.formData.scheduleStatus === status
      );
    },
    setrateExpressionFrequency(frequency) {
      if (frequency) {
        this.formData.recurringSchedule.rateExpression.frequency =
          frequency.value;

        this.checkValidityOnInput(
          frequency.value,
          'rateExpressionFrequency',
          false
        );
      }
    },

    onSelectFlexibleTimeWindow(selectedOption) {
      if (selectedOption.value === 0) {
        this.formData.flexibleTimeWindow.mode = 'OFF';
      } else {
        this.formData.flexibleTimeWindow.mode = 'FLEXIBLE';
      }
      this.formData.flexibleTimeWindow.maximumWindowInMinutes =
        selectedOption.value;
    },

    showToaster(message, title, variant) {
      this.$emit('showToaster', message, title, variant);
    },
    close() {
      this.toggleModal(false, null, null);
    },
    sanatizeData() {
      const formData = JSON.parse(JSON.stringify(this.formData));

      const emptyCronExpression = () => {
        formData.recurringSchedule.cronExpression = {
          dayOfMonth: null,
          dayOfWeek: null,
          hours: null,
          minutes: null,
          month: null,
          year: null,
        };
      };

      const emptyRateExpression = () => {
        formData.recurringSchedule.rateExpression = {
          frequency: null,
          value: null,
          startDate: null,
          endDate: null,
        };
      };

      if (formData.selectedScheduleOccurence.name === 'one_time_schedule') {
        emptyCronExpression();
        emptyRateExpression();
        formData.recurringSchedule.selectedRecurringScheduleType = null;
      } else {
        formData.oneTimeSchedule.dateTime = null;

        if (
          formData.recurringSchedule.selectedRecurringScheduleType.name ===
          'cron_based_schedule'
        ) {
          emptyRateExpression();
        } else {
          emptyCronExpression();
        }
      }

      return formData;
    },
    toggleSteps(mode) {
      if (mode === 'next' && this.step < 1) {
        const isValid = this.validateStep();
        if (isValid) {
          this.setSelectedFlowAtFirstPosition();
          return (this.step += 1);
        }
      }

      if (mode === 'prev' && this.step > 0) {
        return (this.step -= 1);
      }

      if (mode === 'save' && this.step === 1) {
        const isValid = this.validateStep();
        if (isValid) {
          this.onTimeTriggerSave();
        }
      }

      if (mode === 'update' && this.step === 1) {
        const isValid = this.validateStep();
        if (isValid) {
          if (this.isCopyDatabaseItem) {
            this.onTimeTriggerSave();
          } else {
            this.onTimeTriggerUpdate(this.editItemData);
          }
        }
      }
    },
    setSelectedTarget(target) {
      if (target) {
        const isSameWorkflow = this.isSameSelectedWorkflow(target);

        this.formData.target.selectedTarget = {
          ...target,
          selectedTargetCategory:
            this.formData.target.selectedTargetCategory.name,
        };

        if (!isSameWorkflow) {
          this.setEndpointFromSelectedWorkflow(target);
        }
      }
    },
    isSameSelectedWorkflow(target) {
      const selectedTarget = this.formData.target.selectedTarget;

      return (
        selectedTarget?.selectedTargetCategory === 'Workflow' &&
        selectedTarget?.id == target.id
      );
    },
    setEndpointFromSelectedWorkflow(target) {
      if (this.formData.target.selectedTargetCategory.name !== 'Workflow') {
        return;
      }

      const executionUrl = target.executionUrl || null;
      const apiVersionMatch = executionUrl?.match(/\/(v[6-9])(?:\/|$)/i);

      this.formData.target.endPoint = apiVersionMatch
        ? apiVersionMatch[1].toLowerCase()
        : 'custom';
      this.formData.target.customURLendPoint = apiVersionMatch
        ? null
        : executionUrl;
    },
    setTargetCategory(targetCategory) {
      if (targetCategory && targetCategory.name !== 'Database') {
        this.formData.target.selectedTargetCategory = targetCategory;
      }
    },
    setScheduleTypes(scheduleType) {
      if (scheduleType) {
        this.formData.recurringSchedule.selectedRecurringScheduleType =
          scheduleType;
        this.checkValidityOnInput(
          scheduleType,
          'selectedRecurringScheduleType',
          false
        );
      }
    },
    setScheduleStatus(status) {
      this.formData.scheduleStatus = status.name;
      this.checkValidityOnInput(status.name, 'scheduleStatus', false);
    },
    setSchedules(schedule) {
      if (schedule) {
        this.formData.selectedScheduleOccurence = schedule;
      }
    },
    getTimeZones(zones) {
      return `UTC (${moment.tz(zones).format('Z')}) ${zones}`;
    },
    getTargetList() {
      if (
        this.formData.target.selectedTargetCategory &&
        this.formData.target.selectedTargetCategory.name === 'Workflow'
      ) {
        if (
          this.getFlows &&
          Array.isArray(this.getFlows) &&
          this.getFlows.length > 0
        ) {
          return this.getFlows.filter(
            (flow) => flow.policyStatus !== 'pending'
          );
        } else {
          return [];
        }
      }

      if (
        this.formData.target.selectedTargetCategory &&
        this.formData.target.selectedTargetCategory.name === 'Database'
      ) {
        return [];
      }

      return [];
    },
    getInputRegexObject() {
      return {
        rateExpressionValue: /^[1-9]\d*$/,
        customURLendPoint:
          /^(?:https?:\/\/)?(?:[^./]+\.)+([a-zA-Z0-9-]+\.[a-zA-Z]{1,})(?:\/[^\s]*)?$/,
      };
    },
    validateInput(event, category) {
      const value = event.target.value;
      const regexObject = this.getInputRegexObject();
      const categoriesToExclude = [
        'endPoint',
        'scheduleName',
        'scheduleDescription',
        'queryString',
      ];

      const cronExpressionFields = Object.values(CRON_PART_TYPE);
      if (
        value.trim() === '' &&
        category !== 'customURLendPoint' &&
        category !== 'queryString'
      ) {
        return this.inputsErrorArray.push(category);
      }
      if (
        category === 'customURLendPoint' &&
        this.formData.target.endPoint === 'custom' &&
        value.trim() === ''
      ) {
        return this.inputsErrorArray.push(category);
      }

      //  validation for cron expression
      if (cronExpressionFields.includes(category)) {
        this.validateCronPart(value, category);
      }
      if (
        (regexObject[category] !== undefined &&
          value &&
          value.trim() &&
          category !== 'customURLendPoint') ||
        (this.formData.target.endPoint === 'custom' &&
          category === 'customURLendPoint' &&
          value &&
          value.trim() &&
          regexObject[category] !== undefined)
      ) {
        const test = regexObject[category].test(value);
        if (!test) {
          this.addCategoryToErrorArray(category);
        }
        if (test) {
          this.filterCategoryFromInputErrorArray(category);
        }
      } else if (
        categoriesToExclude.includes(category) &&
        value.trim() !== ''
      ) {
        this.filterCategoryFromInputErrorArray(category);
      }

      // validation for dayofmonth or dayofweek
      const cronDayOfWeek = CRON_PART_TYPE.dayOfWeek;
      const cronDayOfMonth = CRON_PART_TYPE.dayOfMonth;
      if ([cronDayOfWeek, cronDayOfMonth].includes(category)) {
        const dayOfWeekValue =
          category === cronDayOfWeek
            ? value
            : this.formData.recurringSchedule.cronExpression.dayOfWeek;
        const dayOfMonthValue =
          category === cronDayOfMonth
            ? value
            : this.formData.recurringSchedule.cronExpression.dayOfMonth;
        if (
          category === cronDayOfWeek &&
          !dayOfMonthValue &&
          dayOfWeekValue &&
          dayOfWeekValue !== '?'
        ) {
          this.formData.recurringSchedule.cronExpression.dayOfMonth = '?';
        }
        if (
          category === cronDayOfMonth &&
          !dayOfWeekValue &&
          dayOfMonthValue &&
          dayOfMonthValue !== '?'
        ) {
          this.formData.recurringSchedule.cronExpression.dayOfWeek = '?';
        }
        if (!dayOfWeekValue || !dayOfMonthValue) {
          this.filterCategoryFromInputErrorArray([
            cronDayOfWeek,
            cronDayOfMonth,
          ]);

          return;
        }

        let isValidFieldDayofweekAndDayOfMonth =
          hasOnlyOneOfDayOfWeekAndDayOfMonthSpecified(
            dayOfMonthValue,
            dayOfWeekValue
          );

        if (isValidFieldDayofweekAndDayOfMonth) {
          this.validateCronPart(dayOfWeekValue, cronDayOfWeek);
          this.validateCronPart(dayOfMonthValue, cronDayOfMonth);
        } else {
          this.addCategoryToErrorArray(cronDayOfMonth, cronDayOfWeek);
        }
      }
    },
    filterCategoryFromInputErrorArray(category) {
      this.inputsErrorArray = [...this.inputsErrorArray].filter((el) =>
        typeof category === 'string' ? el != category : !category.includes(el)
      );
    },
    addCategoryToErrorArray(category) {
      if (!this.inputsErrorArray.includes(category)) {
        this.inputsErrorArray.push(category);
      }
    },
    validateCronPart(cronpartValue, category) {
      if (!isValidCronRulePart(cronpartValue, category)) {
        this.addCategoryToErrorArray(category);
      } else {
        this.filterCategoryFromInputErrorArray(category);
      }
    },
    validateStep() {
      // end

      if (this.step === 1) {
        if (this.inputsErrorArray.length) return false;
        if (this.formData.target.selectedTargetCategory === null) {
          this.addCategoryToErrorArray('selectedTargetCategory');
          return false;
        } else if (this.formData.target.selectedTarget === null) {
          this.showToaster('please select a target', 'Fehlerhaft !', 'danger');
          return false;
        } else if (
          this.formData.target.endPoint === null ||
          this.formData.target.endPoint === ''
        ) {
          this.addCategoryToErrorArray('endPoint');
          return false;
        } else if (
          this.formData.target.endPoint === 'custom' &&
          (this.formData.target.customURLendPoint === null ||
            this.formData.target.customURLendPoint === '')
        ) {
          this.addCategoryToErrorArray('customURLendPoint');
          return false;
        }
      }

      if (this.step === 0) {
        if (
          this.formData.scheduleName === null ||
          this.formData.scheduleName === ''
        ) {
          this.addCategoryToErrorArray('scheduleName');
          return false;
        }
        if (
          this.formData.scheduleDescription === null ||
          this.formData.scheduleDescription === ''
        ) {
          this.addCategoryToErrorArray('scheduleDescription');
          return false;
        }

        if (this.formData.selectedScheduleOccurence !== null) {
          if (
            this.formData.selectedScheduleOccurence.name === 'one_time_schedule'
          ) {
            this.emptyRecurringScheduleValidations();

            const isValidDateTime = this.isDateInFuture(
              this.formData.oneTimeSchedule.dateTime,
              this.savedOneTimeScheduleDate
            );

            if (!isValidDateTime) {
              this.addCategoryToErrorArray('dateTime');
              const errorMessage = this.formData.oneTimeSchedule.dateTime
                ? 'Das Datum muss in der Zukunft liegen.'
                : 'Bitte wählen Sie ein Datum aus.';

              this.showToaster(errorMessage, 'Fehlerhaft !', 'danger');
              return false;
            }
          } else {
            if (
              this.formData.recurringSchedule.selectedRecurringScheduleType ===
              null
            ) {
              this.emptyOneTimeScheduleValidations();
              this.addCategoryToErrorArray('selectedRecurringScheduleType');
              return false;
            } else {
              if (
                this.formData.recurringSchedule.selectedRecurringScheduleType
                  .name === 'rate_based_schedule'
              ) {
                this.emptyRecurringScheduleCronExpressionValidations();
                if (
                  this.formData.recurringSchedule.rateExpression.frequency ===
                  null
                ) {
                  this.addCategoryToErrorArray('rateExpressionFrequency');
                  return false;
                }

                if (
                  this.formData.recurringSchedule.rateExpression.value ===
                    null ||
                  this.formData.recurringSchedule.rateExpression.value === ''
                ) {
                  this.addCategoryToErrorArray('rateExpressionValue');
                  return false;
                }

                const isValidStartDate = this.isDateInFuture(
                  this.formData.recurringSchedule.rateExpression.startDate,
                  this.savedRateExpressionStartDate
                );
                if (!isValidStartDate) {
                  this.addCategoryToErrorArray('startDate');
                  const errorMessage = this.formData.recurringSchedule
                    .rateExpression.startDate
                    ? 'Startdatum muss in der Zukunft liegen.'
                    : 'Bitte wählen Sie ein Startdatum aus.';

                  this.showToaster(errorMessage, 'Fehlerhaft !', 'danger');
                  return false;
                }
                if (
                  this.formData.recurringSchedule.rateExpression.endDate &&
                  this.formData.recurringSchedule.rateExpression.endDate <=
                    this.formData.recurringSchedule.rateExpression.startDate
                ) {
                  this.showToaster(
                    'Das Startdatum darf nicht größer sein als das Enddatum.',
                    'Fehlerhaft !',
                    'danger'
                  );
                  return false;
                }
              } else {
                this.emptyRecurringScheduleRateExpressionValidations();
                let shouldreturn = false;
                Object.keys(this.formData.recurringSchedule.cronExpression).map(
                  (key) => {
                    if (
                      this.formData.recurringSchedule.cronExpression[key] ===
                      null
                    ) {
                      this.addCategoryToErrorArray(key);
                      shouldreturn = true;
                    } else {
                      let test = isValidCronRulePart(
                        this.formData.recurringSchedule.cronExpression[key],
                        key
                      );

                      if (!test) {
                        this.addCategoryToErrorArray(key);
                        shouldreturn = true;
                      }
                    }
                  }
                );

                if (shouldreturn) {
                  return false;
                }
              }
            }
          }
        }

        this.inputsErrorArray = [];
      }

      return true;
    },
    checkValidityOnInput(event, value, isInputEvent) {
      const targetValue = isInputEvent ? event.target.value : event;
      if (targetValue) {
        if (this.inputsErrorArray.includes(value)) {
          this.filterCategoryFromInputErrorArray(value);
        }
      }
    },
    onSelectApiEndPoint(apiEndPointOption) {
      if (apiEndPointOption.value !== 'custom') {
        this.formData.target.customURLendPoint = null;
      }
      this.formData.target.endPoint = apiEndPointOption.value;
    },
    showScrollbar(event) {
      event.target.classList.add('show-scrollbar');
      debouncer(
        () => {
          event.target.classList.remove('show-scrollbar');
        },
        300,
        this,
        'removeScrollClass'
      );
    },
    isValidationError(category) {
      return this.inputsErrorArray.includes(category);
    },

    emptyOneTimeScheduleValidations() {
      this.filterCategoryFromInputErrorArray('dateTime');
    },
    emptyRecurringScheduleValidations() {
      this.emptyRecurringScheduleCronExpressionValidations();
      this.emptyRecurringScheduleRateExpressionValidations();
    },
    emptyRecurringScheduleCronExpressionValidations() {
      this.filterCategoryFromInputErrorArray([
        'minutes',
        'hours',
        'dayOfMonth',
        'month',
        'dayOfWeek',
        'year',
      ]);
    },
    emptyRecurringScheduleRateExpressionValidations() {
      this.filterCategoryFromInputErrorArray([
        'rateExpressionValue',
        'startDate',
      ]);
    },
    async onRefreshFlowList() {
      this.isRefreshing = true;
      await this.$store.dispatch('getFlows');
      this.isRefreshing = false;
      this.workflowList = this.getAllFlows;
      this.setSelectedFlowAtFirstPosition();
    },
    isDateInFuture(startDate, savedDate) {
      if (!startDate) return false;
      const currentCET = moment().tz('Europe/Berlin');
      const startDateCET = moment.tz(
        startDate,
        'YYYY-MM-DDTHH:mm',
        'Europe/Berlin'
      );

      const isSameAsOld =
        this.mode === 'edit' &&
        savedDate &&
        moment(startDate).isSame(moment(savedDate));

      return isSameAsOld || startDateCET.isAfter(currentCET);
    },
    setSelectedFlowAtFirstPosition() {
      if (this.formData?.target?.selectedTarget?.id) {
        const selectedFlowIndex = this.workflowList.findIndex(
          (flow) => flow.id === this.formData.target.selectedTarget.id
        );
        const selectedFlow = this.workflowList[selectedFlowIndex];
        if (selectedFlowIndex !== -1 && selectedFlow) {
          this.workflowList.splice(selectedFlowIndex, 1);
          this.workflowList.unshift(selectedFlow);
        }
      }
    },
  },
  computed: {
    ...mapGetters({ getAllFlows: 'getAllFlows' }),
    getFlows() {
      const filterFlowList = this.workflowList.filter((el) => {
        if (this.workFlowSearch !== '') {
          return (
            el.type === 'app' &&
            el.name.toLowerCase().includes(this.workFlowSearch.toLowerCase())
          );
        }
        return el.type === 'app';
      });

      return filterFlowList;
    },
    getSaveBtnText() {
      return this.step === 0
        ? 'Weiter'
        : this.mode === 'add'
        ? 'Speichern'
        : this.isCopyDatabaseItem
        ? 'Kopieren'
        : 'Aktualisieren';
    },

    getSelectedAPiEndPoint() {
      return this.apiVersionOptions.find(
        (endpoint) => endpoint?.value === this.formData?.target?.endPoint
      );
    },
    getNextTenTriggers() {
      const cronExpression = this.formData.recurringSchedule.cronExpression;
      let isValidCronExpression = true;
      for (let ruleKey in cronExpression) {
        const isvalidRule = cronExpression[ruleKey]
          ? isValidCronRulePart(cronExpression[ruleKey], ruleKey)
          : false;
        if (!isvalidRule) isValidCronExpression = false;
      }

      if (isValidCronExpression) {
        let startDate = new Date();
        const utcIgnoringTimeZone = convertDateToUTCIgnoringTimezone(startDate);
        startDate = utcToZonedTime(utcIgnoringTimeZone);

        const nextTriggerDates = new Array(10)
          .fill(null)
          .map(() => {
            try {
              startDate = startDate
                ? getNextTriggers(startDate, cronExpression)
                : null;

              return startDate;
            } catch (error) {
              return null;
            }
          })
          .filter((item) => !!item);

        const dateInCET = nextTriggerDates.map((item) => {
          const utcDateString = item.toUTCString();

          return `${changeDateStringLocaleToDe(item).replace(
            'GMT',
            ''
          )} (UTC${getTimezoneDifference(utcDateString)})`;
        });
        return dateInCET;
      } else return [];
    },

    isInValidCronExpression() {
      const cronExpressionFields = Object.values(CRON_PART_TYPE);
      return cronExpressionFields.some((field) =>
        this.inputsErrorArray.includes(field)
      );
    },
  },
  async created() {
    if (this.mode === 'add') {
      this.formData.selectedScheduleOccurence =
        this.constants.scheduleOccurence.find((el) => el.id === 1);

      this.formData.target.selectedTargetCategory =
        this.constants.targetCategoryList.find((el) => el.name === 'Workflow');

      this.formData.recurringSchedule.rateExpression.frequency = 'minutes';
    }
    this.workflowList = this.getAllFlows;

    if (this.mode === 'edit') {
      this.isLoading = true;
      try {
        const response = await getCustomDatabaseItem(
          this.editData.databaseID,
          this.editData.itemID
        );
        if (response && response.status === 200 && response.data) {
          const data = response.data;
          this.editItemData = data;
          let occurence = this.constants.scheduleOccurence.find(
            (el) => el.name === data.occurence
          );

          let targetcategory = this.constants.targetCategoryList.find(
            (el) => el.name === data.targetcategory
          );

          let selectedTarget;
          const allFLows = this.getFlows;

          if (allFLows && Array.isArray(allFLows) && allFLows.length > 0) {
            const tempTarget = allFLows.find((el) => el.id == data.targetid);
            selectedTarget = tempTarget
              ? { ...tempTarget, selectedTargetCategory: data.targetcategory }
              : null;
          } else {
            selectedTarget = null;
          }

          let scheduletype = null;

          if (data.occurence === 'recurring_schedule') {
            scheduletype = this.constants.recurringSchedulePattern.find(
              (el) => el.name === data.scheduletype
            );
          }
          const state = !data.state ? 'ENABLED' : data.state;
          this.savedRateExpressionStartDate = data.rateexpressionstartdate;
          this.savedOneTimeScheduleDate = data.dateandtime;
          this.formData = {
            scheduleName: data.schedulename,
            scheduleDescription: data.scheduledescription,
            selectedScheduleOccurence: occurence,
            scheduleStatus: state,
            timeZone: data.timeZone,

            oneTimeSchedule: {
              dateTime: data.dateandtime,
            },

            recurringSchedule: {
              selectedRecurringScheduleType: scheduletype,
              rateExpression: {
                value: data.rateexpressionvalue,
                frequency: data.rateexpressionfrequency,
                startDate: data.rateexpressionstartdate,
                endDate: data.rateexpressionenddate,
              },
              cronExpression: {
                minutes: data.cronexpressionminutes,
                hours: data.cronexpressionhours,
                dayOfMonth: data.cronexpressiondayOfMonth,
                month: data.cronexpressionmonth,
                dayOfWeek: data.cronexpressiondayOfWeek,
                year: data.cronexpressionyear,
              },
            },

            target: {
              selectedTargetCategory: targetcategory,
              selectedTarget: selectedTarget,
              queryString: data.urlQueryString,
              endPoint: data.endPoint,
              customURLendPoint: data.apiEndPoint,
            },

            flexibleTimeWindow: {
              mode: data?.flexibletimewindow?.Mode ?? 'OFF',
              maximumWindowInMinutes:
                data?.flexibletimewindow?.MaximumWindowInMinutes ?? 0,
            },
          };
        }

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        this.showToaster({ error }, 'Fehlerhaft !', 'danger');
        this.toggleModal(false, null, null);
      }
    }
  },
  components: { GeneralDropdown },
};
</script>
<style scoped>
.manage-timetrigger-modal .modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1001;
}

.manage-timetrigger-modal .modal-fullscreen {
  position: fixed;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  text-align: center;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  border-radius: 20px;
  width: 90%;
  height: 93%;
  top: 3%;
  z-index: 1001;
  box-shadow: 1px 1px 50px 20px rgba(0, 0, 0, 0.29);
}

.manage-timetrigger-modal .modal-fullscreen .header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  box-sizing: border-box;
}

.manage-timetrigger-modal .modal-fullscreen .header .btn-close {
  cursor: pointer;
  display: block;
}

.manage-timetrigger-modal .modal-fullscreen .content {
  padding: 0px 80px;
  overflow-y: scroll;
}

.manage-timetrigger-modal .modal-fullscreen .content .step-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.manage-timetrigger-modal .modal-fullscreen .content .input-container {
  text-align: start;
  margin-bottom: 15px;
}

.manage-timetrigger-modal .modal-fullscreen .content .input-container label {
  margin-bottom: 5px;
}

.manage-timetrigger-modal
  .modal-fullscreen
  .content
  .input-container
  .occurence-container,
.target-container,
.date-time-container,
.recurring-schedule-container,
.status-schedule-container {
  display: flex;
  justify-content: space-between;
  align-content: center;
}

.manage-timetrigger-modal
  .modal-fullscreen
  .content
  .input-container
  .date-time-container
  .date-time-input-container {
  width: 48%;
}

.manage-timetrigger-modal
  .modal-fullscreen
  .content
  .input-container
  .radio-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 48%;
  border: 1px solid #dee3e9;
  padding: 8px;
  border-radius: 6px;
}

.manage-timetrigger-modal
  .modal-fullscreen
  .content
  .input-container
  .radio-container
  label {
  margin-bottom: 0;
  margin-left: 10px;

  font-size: 14px;
  font-weight: 500;
  /* line-height: 16.94px; */
}

.manage-timetrigger-modal input[type='text'],
input[type='datetime-local'],
input[type='number'],
input[type='date'],
.frequency-general-dropdown,
select,
.api-endpoint-general-dropdown {
  cursor: text;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  padding: 15px 20px 15px 20px;
  height: 35px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  position: relative;
}

.manage-timetrigger-modal .frequency-general-dropdown,
.manage-timetrigger-modal .api-endpoint-general-dropdown {
  padding: 0;
}

.manage-timetrigger-modal input:focus,
select,
textarea {
  outline: none;
}

.manage-timetrigger-modal select {
  padding: 5px 20px 5px 20px;
}

.manage-timetrigger-modal input[type='radio'] {
  height: 15px;
  width: 15px;
  cursor: pointer;
}

.manage-timetrigger-modal input[type='number'] {
  -moz-appearance: textfield;
}

.manage-timetrigger-modal
  .input-container
  input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
  display: none;
}

.manage-timetrigger-modal textarea {
  resize: none;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding: 15px 20px 15px 20px;
  margin-bottom: 0;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 400;
  overflow: hidden;
  width: 100%;
}

.manage-timetrigger-modal
  .modal-fullscreen
  .content
  .schedule-pattern-container {
  flex-grow: 1;
  margin-top: 45px;
}

.manage-timetrigger-modal
  .modal-fullscreen
  .content
  .input-container
  .recurring-schedule-container
  .radio-container {
  background-color: white;
}

.manage-timetrigger-modal
  .modal-fullscreen
  .content
  .input-container
  .rate-expression-container {
  display: flex;
  align-content: center;
}
.manage-timetrigger-modal
  .modal-fullscreen
  .content
  .input-container
  .rate-expression-container
  .frequency-general-dropdown {
}

.manage-timetrigger-modal
  .modal-fullscreen
  .content
  .input-container
  .rate-expression-container
  .dropdown-container {
  width: 58%;
  margin-left: 15px;
}

.manage-timetrigger-modal
  .modal-fullscreen
  .content
  .input-container
  .rate-expression-container
  .dropdown-container
  ::v-deep
  button {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.manage-timetrigger-modal
  .modal-fullscreen
  .content
  .input-container
  .rate-expression-container
  .dropdown-container
  ::v-deep
  ul {
  width: 100%;
}

.manage-timetrigger-modal
  .modal-fullscreen
  .content
  .input-container
  .cron-expression-container {
  display: flex;
  align-content: center;
  justify-content: space-between;
}

.manage-timetrigger-modal
  .modal-fullscreen
  .content
  .input-container
  .cron-expression-container
  .cron-input-container {
  width: 15%;
}

.modal-fullscreen .footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 80px 17px 80px;
}

.modal-fullscreen .footer button {
  cursor: pointer;
  text-decoration: none;
  border: 3px solid rgba(0, 0, 0, 0.916);
  border-radius: 0.375em;
  font-family: proxima-nova, Helvetica Neue, Arial, sans-serif;
  font-weight: 400;
  line-height: 23px;
  padding: 0.6rem 1.6rem;
  font-size: 0.9375rem;
  margin-top: 5px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  min-width: 125px;
}

.modal-fullscreen .footer .save-btn {
  background-color: rgba(0, 0, 0, 0.916);
  color: rgba(255, 255, 255, 0.951);
  margin-left: 10px;
}
.modal-fullscreen .footer .save-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.modal-fullscreen .footer .cancel-btn {
  color: rgba(0, 0, 0, 0.916);
  background-color: white;
}

.modal-fullscreen .content .grid-container {
  display: flex;
  flex-wrap: wrap;
  margin: 35px -10px;
  min-height: 380px;
  max-height: 380px;
  overflow-y: auto;
  padding-top: 20px;
}

.modal-fullscreen .content .grid-container .target-grid-block {
  min-height: 100px;
  max-height: 100px;
  width: 33.33%;
  padding: 0 10px;
  margin-bottom: 20px;
  cursor: pointer;
}
.modal-fullscreen .content .grid-container .target-grid-block-inner {
  box-shadow: 0 0 4px rgb(43 59 93 / 29%);
  height: 100%;
  border-radius: 4px;
  transition: all 300ms ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 20px 20px 10px;
}

.modal-fullscreen
  .content
  .grid-container
  .target-grid-block-inner
  > :nth-child(1) {
  width: 20%;
}

.modal-fullscreen
  .content
  .grid-container
  .target-grid-block-inner
  > :nth-child(2) {
  width: 70%;
  text-align: left;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.modal-fullscreen
  .content
  .grid-container
  .target-grid-block-inner
  > :nth-child(3) {
  width: 10%;
}

.modal-fullscreen .content .grid-container .target-grid-block-inner:hover {
  transform: translateY(-4px);
  box-shadow: 0 0 16px rgb(43 59 93 / 29%);
}

.modal-fullscreen .content .validation-error {
  border: 1px solid #ff3d02 !important;
}

::v-deep .toast .toast-header button.close {
  margin-left: auto;
  margin-bottom: 0;
  font-size: 1.3rem;
  line-height: 0;
  color: #000;
  opacity: 0.5;
  border: none;
  background: transparent;
}
::v-deep .toast:not(.show) {
  display: block;
}

.manage-timetrigger-modal .modal-fullscreen .loadingoverlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  text-align: center;
}

.manage-timetrigger-modal .modal-fullscreen .loadingoverlay .progress-icon {
  display: block;
  top: 50%;
  left: 0;
  right: 0;
  margin: 0 auto;
  transform: translateY(-50%);
}

.manage-timetrigger-modal
  .modal-fullscreen
  .loadingoverlay
  .progress-icon:after {
  content: ' ';
  display: block;
  width: 70px;
  height: 70px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #fff;
  border-color: #1f2532c7 transparent #1f2532c7 transparent;
  animation: progress-icon 1.2s linear infinite;
}

@keyframes progress-icon {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.modal-fullscreen
  .content
  .occurence-wrapper
  .schedule-pattern-container
  .rate-expression-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-fullscreen
  .content
  .occurence-wrapper
  .schedule-pattern-container
  .rate-expression-wrapper
  > :nth-child(1) {
  width: 48%;
}

.modal-fullscreen
  .content
  .occurence-wrapper
  .schedule-pattern-container
  .rate-expression-wrapper
  > :nth-child(2) {
  width: 22%;
}

.modal-fullscreen
  .content
  .occurence-wrapper
  .schedule-pattern-container
  .rate-expression-wrapper
  > :nth-child(3) {
  width: 22%;
}

.manage-timetrigger-modal .w-48 {
  width: 48%;
}

::v-deep .api-endpoint-dropdown-container .dropdown-menu {
  width: 100% !important;
}

.manage-timetrigger-modal .radio-container.disabled-radio-container,
.manage-timetrigger-modal .radio-container.disabled-radio-container label,
.manage-timetrigger-modal .radio-container.disabled-radio-container input {
  cursor: not-allowed !important;
}

.manage-timetrigger-modal .recurring-schedule-container .radio-container input,
.manage-timetrigger-modal .status-schedule-container .radio-container input {
  margin-top: 4px;
}
.manage-timetrigger-modal .radio-container input {
  accent-color: rgba(149, 61, 150, 1);
  width: 18px;
  height: 18px;
}
.manage-timetrigger-modal .recurring-schedule-container .radio-container,
.manage-timetrigger-modal .status-schedule-container .radio-container {
  align-items: start !important;
}
.manage-timetrigger-modal .recurring-schedule-container .radio-container label,
.manage-timetrigger-modal .status-schedule-container .radio-container label {
  font-weight: 500;
}
.manage-timetrigger-modal .recurring-schedule-container .radio-container p,
.manage-timetrigger-modal .status-schedule-container .radio-container p {
  padding: 10px;
  padding-bottom: 0;
  margin-top: 4px;
  margin-bottom: 0;
}
.manage-timetrigger-modal .recurring-description,
.manage-timetrigger-modal .status-description {
  font-size: 14px;
  font-weight: 400;
  text-align: left;
}
.manage-timetrigger-modal .datetime-local {
  font-size: 14px;
  font-weight: 500;
  text-align: left;
}

.manage-timetrigger-modal .workFlowSearch1 {
  position: relative;
  z-index: 0;
  height: 40px;
  max-width: calc(100% - 585px);
  width: 100%;
}
.manage-timetrigger-modal .workFlowSearch1 input {
  padding-left: 40px !important;
  width: 100% !important;
  max-width: 100%;
}
.manage-timetrigger-modal .workFlowSearch1 img {
  position: absolute;
  left: 10px;
  top: 10px;
}
.manage-timetrigger-modal input::placeholder {
  font-size: 12px;
  font-weight: 400;
  text-align: left;
}

.manage-timetrigger-modal .workflowsearchinput {
  height: 40px !important;
}
.manage-timetrigger-modal .cron-next-triggers-container {
  border: 1px solid #dee3e9;
  border-radius: 6px;
  padding: 18px;
}
.manage-timetrigger-modal .invalid-cron-expression {
  color: #ff3d02;
}
.manage-timetrigger-modal
  .date-time-input-container.rate-expression-timezone-input,
.manage-timetrigger-modal .flexible-time-window-container {
  margin-block: 15px;
  width: 48%;
}

.manage-timetrigger-modal
  .flexible-time-window-container
  .dropdown-container
  ::v-deep
  button {
  display: flex;
  justify-content: space-between;
}
.manage-timetrigger-modal
  .flexible-time-window-container
  .dropdown-container
  ::v-deep
  ul {
  width: 100%;
}

.manage-timetrigger-modal .step-container .search-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.manage-timetrigger-modal .step-container .refresh-button {
  display: flex;
  flex-flow: row-reverse;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
  padding: 0;
}

.manage-timetrigger-modal .step-container .refresh-button.rotation img {
  animation: rotation 1.5s infinite linear;
}
.manage-timetrigger-modal .step-container .refresh-button img {
  width: 30px;
}

.manage-timetrigger-modal .step-container .refresh-button:hover {
  transform: scale(1.1) rotate(0);
}
.manage-timetrigger-modal .step-container .refresh-button img:hover {
  transform: scale(1.1) rotate(0);
}
@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-359deg);
  }
}
</style>
